import actions from "./actions";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  // States for handling login and donor personal details creation
  isFetching: false,
  successMessage: "",
  errorMessage: "",
  actionType: "",
  status_code: 0,
});

export default function donorReducer(state = initialState, action) {
  switch (action.type) {
    // Donor Personal Details Creation Actions
    case actions.DONOR_PERSONAL_DETAILS_CREATE_REQUEST:
      return Immutable.merge(state, {
        isFetching: true,
        actionType: "DONOR_PERSONAL_DETAILS_CREATE_REQUEST",
      });
    case actions.DONOR_PERSONAL_DETAILS_CREATE_SUCCESS:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: "DONOR_PERSONAL_DETAILS_CREATE_SUCCESS",
        successMessage: action.message,
        status_code: action.status_code,
      });
    case actions.DONOR_PERSONAL_DETAILS_CREATE_ERROR:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: "DONOR_PERSONAL_DETAILS_CREATE_ERROR",
        errorMessage: action.message,
        status_code: action.status_code,
      });

    //donor details update
    case actions.DONOR_DETAILS_UPDATE_REQUEST:
      return Immutable.merge(state, {
        isFetching: true,
        actionType: actions.DONOR_DETAILS_UPDATE_REQUEST,
      });
    case actions.DONOR_DETAILS_UPDATE_SUCCESS:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: actions.DONOR_DETAILS_UPDATE_SUCCESS,
        successMessage: action.message,
        status_code: action.status_code,
      });
    case actions.DONOR_DETAILS_UPDATE_ERROR:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: actions.DONOR_DETAILS_UPDATE_ERROR,
        errorMessage: action.message,
        status_code: action.status_code,
      });

    //donation details create
    case actions.DONATION_DETAILS_CREATE_REQUEST:
      return Immutable.merge(state, {
        isFetching: true,
        actionType: actions.DONATION_DETAILS_CREATE_REQUEST,
      });
    case actions.DONATION_DETAILS_CREATE_SUCCESS:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: actions.DONATION_DETAILS_CREATE_SUCCESS,
        successMessage: action.successMessage,
        status_code: action.status_code,
      });
    case actions.DONATION_DETAILS_CREATE_ERROR:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: actions.DONATION_DETAILS_CREATE_ERROR,
        errorMessage: action.errorMessage,
        status_code: action.status_code,
      });

      case actions.SEND_MAIL_REQUEST:
        return Immutable.merge(state, {
          isFetching: true,
          actionType: actions.SEND_MAIL_REQUEST,
        });
      case actions.SEND_MAIL_REQUEST_SUCCESS:
        return Immutable.merge(state, {
          isFetching: false,
          actionType: actions.SEND_MAIL_REQUEST_SUCCESS,
          successMessage: action.successMessage,
          // status_code: action.status_code,
        });
      case actions.SEND_MAIL_REQUEST_ERROR:
        return Immutable.merge(state, {
          isFetching: false,
          actionType: actions.SEND_MAIL_REQUEST_ERROR,
          errorMessage: action.errorMessage,
          // status_code: action.status_code,
        });

    case actions.RESET_ACTIONTYPE:
      return Immutable.merge(state, {
        actionType: "",
        successMessage: "",
        errorMessage: "",
        isFetching: false,
        status_code: 0,
      });
    default:
      return state;
  }
}
